import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Tab.css';

class Tab extends Component {
    static propTypes = {
        activeTab: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    onClick = (evt) => {
        const { label, onClick } = this.props;
        onClick(label);
    }

    handleKey = (e) => {
        if (e.key == 'Enter')
            this.onClick()
    }

    render() {
        const {
            onClick,
            props: {
                activeTab,
                label,
            },
        } = this;

        // let className = 'tab-list-item no-select';

        // if (activeTab === label) {
        //     className += ' tab-list-active';
        // }

        let className = 'tab-list-item-schw no-select';

        if (activeTab === label) {
            className += ' tab-list-active-schw';
        }

        return (
            <>
                <li id={'li-' + label}
                    className={className}
                    onClick={onClick}
                    onKeyDown={e => this.handleKey(e)}
                    role="tab"
                    tabIndex={0}
                >
                    {label}
                </li>
            </>
        );
    }
}


export default Tab;